const ACCENTS_CASE_MAP = {
  á: 'a',
  é: 'e',
  í: 'i',
  ó: 'o',
  ú: 'u',
  '(': '\\(',
  ')': '\\)',
};
export class CoincidenceTokenizer {
  regex;

  options;

  constructor(options) {
    this.options = options;
  }

  buildRegex() {
    this.regex = new RegExp(`(${this.replaceAccents(this.options.search)})`, 'gi');

    return this.regex;
  }

  defaultResult = () => [
    {
      start: 0,
      end: this.options.base.length,
      type: 'text',
      word: this.options.base,
    },
  ];

  replaceAccents(word) {
    const ignoreAccents = this.options?.ignoreAccents || false;
    if (ignoreAccents) {
      return word
        .split('')
        .map((letter) => ACCENTS_CASE_MAP[letter] || letter)
        .join('')
        .trim();
    }

    return word;
  }

  getCoincidences() {
    this.buildRegex();
    const numCoincidences = this.options?.coincidencesCount || -1;

    const resultRegex = Array.from(this.replaceAccents(this.options.base).matchAll(this.regex));
    const result = resultRegex
      .map((arr) => {
        const start = arr?.index || 0;
        const end = (arr?.index || 0) + this.options.search.length;
        return {
          start,
          end,
          type: 'coincidence',
          word: this.options.base.slice(start, end),
        };
      })
      .sort((a, b) => a.start - b.start);
    if (numCoincidences !== -1) {
      return result.slice(0, numCoincidences);
    }
    return result;
  }

  fillTokens(mapRegex) {
    const { base } = this.options;
    let aux = 0;
    const tokens = [];
    let pointer = 0;
    while (pointer < base.length && aux < mapRegex.length && mapRegex.length) {
      const val = mapRegex[aux];
      if (val) {
        const word = base.slice(pointer, val.start);
        tokens.push({
          start: pointer,
          end: pointer,
          word,
          type: 'text',
        });
        tokens.push(val);
        pointer = val.end;
        // eslint-disable-next-line no-plusplus
        aux++;
        if (pointer < base.length && aux === mapRegex.length) {
          const start = val.end;
          const end = val.end + (base.length - pointer);
          tokens.push({
            start,
            end,
            word: base.slice(start, end),
            type: 'text',
          });
        }
      }
    }
    return tokens;
  }

  get tokens() {
    const { search } = this.options;
    if (!search.length) {
      return this.defaultResult();
    }
    const coincidences = this.getCoincidences();

    if (!coincidences.length) {
      return this.defaultResult();
    }
    return this.fillTokens(coincidences);
  }
}
